export default "__VITE_ASSET__BWybQZnn__"